

import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import { AuthenticatedLayout } from "../../layouts";
import { CountrySetup } from "../../components/CountrySetup";


export const CountrySetupPage = () => {
  return (
    <AuthenticatedLayout
      pageTitle="Country Setup"
      pageTitleIcon={<DescriptionOutlinedIcon />}
      breadcrumbCurrentPageName=""
      breadcrumbLinks={[
        { text: "Country Setup", navigateTo: "/country/setup" }
      ]}
      mainContents={<CountrySetup />}
    />
  );
};
